'use strict';

const { pubdb } = Function('return this')();
const {
    $, next_tick, ajax_get, display_when_ready, path_root, relogin,
    get_csrf_token, echo_errors, toggle_diff, echo,
    mustache, window, document,
} = pubdb;
const {
    log_entry_id, log_from, JsDiff, history, log_entry_source,
} = window;


pubdb.pub_log = {
    advance_user (last_id) {
        next_tick(function () {
            ajax_get(
                `${path_root}/user/${log_entry_id}/log/${last_id}.json`,
                success, error,
            );
        });
        return 0;
    },
};

const edit_log_markup = (
    '<li id="edit-entry-{{id}}" style="border:1px solid #ccc; background:#f8f8f8; padding:1ex; margin-bottom:1ex">' +
        '{{> DISPLAY_EDITOR_LOG_ENTRY}}' +
    '</li>'
);

const edit_log_no_data = '{{^data}}Zu Ihrer Anfrage existiert kein Logbuch-Eintrag.{{/data}}';

let ajax_path = `/${log_entry_source}/${log_entry_id}/log.json`;
let ajax_markup = (
    '<ul class="no-image-list form">' +
        '{{#data}}' + edit_log_markup + '{{/data}}' +
    '</ul>' +
    edit_log_no_data
);
switch (log_entry_source) {
/*
    case 'journal':
    case 'forschungsprojekt':
    case 'author':
        break;
*/
    case 'log':
        ajax_path = `/log/${log_entry_id}.json`;
        break;

    case 'pub':
        ajax_markup = (
            '{{#data}}' +
                '{{#deleted}}' +
                    '<strong class="error">Diese Publikation wurde gelöscht</strong>' +
                '{{/deleted}}' +

                '<h3>Änderungen an der Publikation:</h3>' +
                '<ul class="no-image-list form">' +
                    '{{#pub}}' + edit_log_markup + '{{/pub}}' +
                '</ul>' +

                '<h3>Änderungen an den Autoren:</h3>' +
                '<ul class="no-image-list form">' +
                    '{{#authors}}' + edit_log_markup + '{{/authors}}' +
                '</ul>' +
            '{{/data}}'
        );
        break;

    case 'user':
        ajax_markup = (
            '<ul class="no-image-list form">' +
                '{{#data}}' + edit_log_markup + '{{/data}}' +
            '</ul>' +
            edit_log_no_data +
            '{{#next}}<button onclick="return pubdb.pub_log.advance_user({{next}});">Weiter</button>{{/next}}'
        );
        break;

    case 'impact_factors':
        ajax_path = '/journal/' + log_entry_id + '/if/';
        break;

    case 'full':
        ajax_path = `/log.json`;
        ajax_markup = function (view, partials, stack, lookup, escapeHTML, renderSection, render) {
            if (!view.data.length) {
                return render(edit_log_no_data);
            }
            function next_page () {
                ajax_get(
                    `${path_root}/log.json?from=${view.data[view.data.length-1].id}`,
                    function (data) {
                        var content = $('#content');
                        if (content && (content = content[0])) {
                            content.scrollIntoView(true);
                        }

                        if (data.success && history) {
                            history.replaceState(
                                null,
                                document.title,
                                `${path_root}/log/?from=${view.data[view.data.length-1].id}`,
                            );
                        }

                        success(data);
                    },
                    error,
                );
            }
            next_tick(function () {
                $('#pubdb_data button').on('click', (ev) => {
                    ev.preventDefault()
                    next_tick(next_page);
                });
            });
            return (
                render(
                    '<ul class="no-image-list form">' +
                        '{{#data}}' + edit_log_markup + '{{/data}}' +
                    '</ul>', view,
                ) + '<button>Nächste Seite</button>'
            );
        };
        break;
}

function success (data) {
    var dest = $('#pubdb_data');
    if (!data.success) {
        if ('login_required' in data.errors) {
            relogin();
        } else if ('csrf_token' in data.errors) {
            get_csrf_token();
        } else {
            echo_errors(data.errors);
            dest.html($('<strong/>').text('Ein Fehler trat auf. Bitte beachten Sie die Benachrichtigungen.'));
        }
        return;
    }

    dest.html(mustache(ajax_markup, {data:data.data, next:data.next}));
}

$(function () {
    $('#pubdb_data').on('click', '.-show-diff a', function (ev) {
        ev.preventDefault();
        const self = $(this);
        toggle_diff(self.closest('tr'), JsDiff[self.data('diff') || 'diffWordsWithSpace']);
    });
});

function error (data, err, xhr) {
    echo('warn', `Fehler (${data.statusText}) - bitte versuchen Sie es erneut`);
}

ajax_get(
    path_root + ajax_path + (log_from ? `?from=${log_from}` : ''),
    display_when_ready(success),
    display_when_ready(error),
);
